import { Component, OnInit } from '@angular/core';
import { SchemaApiService } from '../../../core/services/schema-api.service';
import { ValidationRules } from '../../../core/models/validation-rule.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
      selector: 'app-validation-manager',
      standalone: true,
      imports: [CommonModule, FormsModule],
      templateUrl: './validation-manager.component.html'
})
export class ValidationManagerComponent implements OnInit {

      // --- Pagination Properties ---
      pageIndex: number = 0;
      pageSize: number = 10;
      total: number = 0;

      rules: ValidationRules[] = [];
      filteredRules: ValidationRules[] = [];
      searchTerm: string = '';

      isModalOpen: boolean = false;
      isEditMode: boolean = false;

      currentRule: ValidationRules = this.getEmptyRule();
      jsonString: string = '';

      constructor(private ruleService: SchemaApiService) { }

      ngOnInit(): void {
            this.loadRules();
      }

      getEmptyRule(): ValidationRules {
            return {
                  id: undefined,
                  entityName: '',
                  ruleCode: '',
                  phase: 'COMPUTATIONAL',
                  scope: 'FIELD',
                  ruleType: 'DSL',
                  severity: 'ERROR',
                  message: '',
                  active: true,
                  sqlExpression: '',
                  ruleJson: null
            };
      }

      // Automatically fetches server-side paginated data
      loadRules(): void {
            this.ruleService.getAll(this.pageIndex, this.pageSize, this.searchTerm).subscribe({
                  next: (response) => {
                        this.rules = response.items; // Just the current page's data
                        this.total = response.totalCount; // Total records in DB
                  },
                  error: (err) => {
                        console.error(err);
                        alert('Failed to load rules.');
                  }
            });
      }

      // Triggered by your search input
      filterRules(): void {
            this.pageIndex = 0; // Reset to first page on search
            this.loadRules();   // Fetch filtered data from server
      }
      // get total(): number {
      //       return this.filteredRules.length;
      // }
      get totalPages(): number {
            return Math.ceil(this.total / this.pageSize);
      }

      // The UI uses this variable. We now just return the server-provided array.
      get paginatedRules(): ValidationRules[] {
            return this.rules;
      }

      // --- Pagination Methods ---
      goToPage(index: number): void {
            if (index >= 0 && index < this.totalPages) {
                  this.pageIndex = index;
                  this.loadRules(); // Fetch new page from server
            }
      }

      changePageSize(event: any): void {
            this.pageSize = Number(event.target.value);
            this.pageIndex = 0;
            this.loadRules(); // Fetch new page size from server
      }
      openCreateModal(): void {
            this.isEditMode = false;
            this.currentRule = this.getEmptyRule();
            this.jsonString = `{
  "assert": { "operator": ">=", "value": 0 },
  "target": ""
}`;
            this.isModalOpen = true;
      }

      openEditModal(rule: ValidationRules): void {
            this.isEditMode = true;
            this.currentRule = { ...rule };

            if (rule.ruleJson && typeof rule.ruleJson === 'object') {
                  this.jsonString = JSON.stringify(rule.ruleJson, null, 2);
            } else {
                  this.jsonString = rule.ruleJson ? String(rule.ruleJson) : '';
            }

            this.isModalOpen = true;
      }

      closeModal(): void {
            this.isModalOpen = false;
      }

      save(): void {
            try {
                  if (this.jsonString && this.jsonString.trim() !== '') {
                        this.currentRule.ruleJson = JSON.parse(this.jsonString);
                  } else {
                        this.currentRule.ruleJson = null;
                  }

                  if (!this.currentRule.sqlExpression) {
                        this.currentRule.sqlExpression = '';
                  }

            } catch (e) {
                  alert('Invalid JSON format.');
                  return;
            }

            const request = (this.isEditMode && this.currentRule.id)
                  ? this.ruleService.update(this.currentRule)
                  : this.ruleService.create(this.currentRule);

            request.subscribe({
                  next: () => {
                        this.closeModal();
                        this.loadRules();
                  },
                  error: (err) => {
                        console.error(err);
                        alert('Save failed.');
                  }
            });
      }

      deleteRule(id?: string): void {
            if (!id) return;

            if (confirm('Delete this rule?')) {
                  this.ruleService.delete(id).subscribe(() => {
                        // Edge case: if you delete the last item on a page, go back one page
                        if (this.rules.length === 1 && this.pageIndex > 0) {
                              this.pageIndex--;
                        }
                        this.loadRules();
                  });
            }
}}
